function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 192 192"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m41.4 129.6 50-.4c1.1 0 2 .9 2 2v2.4c.1 10.5-8.4 19.1-18.9 19.1l-32.1.3c-6.6.1-12-5.3-12.1-11.9v-.2c0-6.2 4.9-11.2 11.1-11.3zm-9.7-76.7-.2.1c-6.3 2.1-9.7 8.9-7.6 15.2l10.2 30.6c3.3 10 14.1 15.3 24 12l2.3-.8c1-.3 1.6-1.5 1.3-2.5L45.8 60c-1.9-5.9-8.3-9-14.1-7.1zM115.8 27l-.1-.2c-3.9-5.3-11.4-6.5-16.8-2.5l-26 19.2c-8.4 6.2-10.2 18.1-4 26.6l1.4 1.9c.7.9 1.9 1.1 2.8.4l40.3-29.7c5-3.7 6-10.7 2.4-15.7zm50.6 72 .1-.2c3.9-5.4 2.6-12.9-2.8-16.7l-26.2-18.7c-8.5-6.1-20.4-4.1-26.5 4.4l-1.4 1.9c-.6.9-.4 2.1.5 2.8l40.7 29.1c5 3.6 12 2.4 15.6-2.6zm-52.8 70.4.2.1c6.3 2 13.1-1.5 15.1-7.8l9.7-30.7c3.2-10-2.4-20.7-12.4-23.8l-2.3-.7c-1.1-.3-2.2.3-2.5 1.3l-15.1 47.7c-1.9 5.7 1.4 12 7.3 13.9z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 12,
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b581d70264b2210ae88b42049c3ba2a2.svg";
export { ForwardRef as ReactComponent };